import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../state/reducers/global";
import ModalInsert from "../../components/ModalInsert";
import LogisticsStatus from "../../components/LogisticsStatus";
import { LOGISTICS_STATUS_MAP } from "../../../shared/utility";

const LogisticsStatusModalInsert = () => {
  const dispatch = useDispatch();

  const logisticsStatus = useSelector(
    (state) => state.orders?.logisticsStatus?.data
  );

  const timelineData = () => {
    if (!logisticsStatus.steps.length) {
      return null;
    }
    return logisticsStatus.steps.map((el) => ({
      text: el.stepName,
      status: LOGISTICS_STATUS_MAP[el.stepType],
      additionalText: el.additionalText ? el.additionalText.join(" ") : null,
    }));
  };

  const onClose = () => {
    dispatch(closeModal());
  };

  const onCollectionLinkBtn = () => {
    if(logisticsStatus?.collectionBookingPortalLink){ 
      window.open(logisticsStatus?.collectionBookingPortalLink, "_blank");
    }
  }

  const footerActions = [
    {
      content: "Close",
      action: onClose,
      type: "ghost",
    }
  ]

  const getLogisitcsProps = () => {
    switch (logisticsStatus.logisticsType) {
      case "Delivery":
        return {
          headerText: "Delivery Status",
          subHeaderText:
            "Please find the below information regarding your vehicle delivery.",
          data: timelineData(),
          issueMsg: logisticsStatus.warningMessage,
          footerActions: footerActions,
          onClose: onClose,
          className: "delivery-status",
          qaClassName: "qa-delivery-status",
        };
      case "Collection":
        logisticsStatus?.collectionBookingPortalLink && (
          footerActions.unshift({
            content: "Book Collection",
            action: onCollectionLinkBtn,
            type: "primary",
          })
        )
        
        return {
          headerText: "Collection Status",
          subHeaderText:
            "Please find the below information regarding your vehicle collection.",
          collectionBookingPortalLink: logisticsStatus?.collectionBookingPortalLink,
          data: timelineData(),
          footerActions: footerActions,
          className: "collection-status",
          qaClassName: "qa-collection-status",
        };
      default:
        break;
    }
  };

  return (
    <ModalInsert layout="flex">
      <LogisticsStatus {...getLogisitcsProps()} />
    </ModalInsert>
  );
};

export default LogisticsStatusModalInsert;
